import { SearchOrganizationsByEnum } from "@organization/models/Organization";

export class CreateParamsForOrganizations extends URLSearchParams {
  withPagination(pageSize: number, pageIndex?: number) {
    // For now, pageSize has to be hardcoded to remain same as before on UI,
    // but since Apr-2025 for GET /organizations endpoint if pageSize is omitted, then backend return all records
    this.append("pageSize", pageSize.toString());

    if (pageIndex !== undefined) {
      this.append("offset", (pageIndex * pageSize).toString());
    }
  }

  withSorting(sortField: string, sortDirection: string) {
    if (sortField) {
      if (sortField === "country") sortField = "countrycode";
      if (sortField === "external-id") sortField = "externalId";
      if (sortField === "created-on") sortField = "createdOn";

      if (sortDirection === "ascending") {
        this.append("orderby", `${sortField}:asc`);
      } else {
        this.append("orderby", `${sortField}:desc`);
      }
    }
  }

  withSearch(searchQuery?: string, searchBy?: SearchOrganizationsByEnum) {
    if (searchQuery) {
      if (searchBy === SearchOrganizationsByEnum.ByName) {
        this.append("search", searchQuery);
      } else if (searchBy === SearchOrganizationsByEnum.ByExternalId) {
        this.append("searchExternalId", searchQuery);
      }
    }
  }
}
